import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { IoArrowBackSharp } from "react-icons/io5";
import { useFormik } from "formik";
import * as Yup from "yup";

import CustomTextField from "../../../../../components/custom_text_field/CustomTextField";
import CustomAutoCompleteDropdown from "../../../../../components/custom_auto_complete_dropdown/CustomAutoCompleteDropdown";
import { get_status } from "../../../../../api/statusApis";
import { ErrorToast, SuccessToast } from "../../../../../toast/toasts";

import "./expenseFormStyle.css";
import { create_expense_head, get_expense_head_by_id, update_expense_head } from "../../../../../api/expenseHeadApis";

function ExpenseForm() {
  const navigate = useNavigate();
  const { expense_id } = useParams();
  const [statusOptions, setStatusOptions] = useState([]);
  useEffect(() => {
    fetchStatusList();
    if (expense_id) {
      get_expense_head_by_id(expense_id).then(response => {
        const data = response?.data?.data;
        formik.setValues({
          expense_name: data.ExpenseName || "",
          expense_status: data.status || "",
        });
      });
    }
  }, [expense_id]);

  const fetchStatusList = () => {
    get_status()
      .then((response) => {
        const options = response.map((item) => ({
          label: item.status_name,
          value: item.id,
        }));
        setStatusOptions(options);
      })
      .catch((error) => console.log(error));
  };

  const formik = useFormik({
    initialValues: {
      expense_name: "",
      expense_status: 1,
    },
    validationSchema: Yup.object({
      expense_name: Yup.string().required("Name is required"),
      expense_status: Yup.string().required("Status is required"),
    }),

    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("ExpenseName", values.expense_name);
      formData.append("status", values.expense_status);
      if(expense_id){
         formData.append("expense_head_id", expense_id);
      }
      const apiCall = expense_id
        ? update_expense_head(formData)
        : create_expense_head(formData);
      apiCall
        .then((response) => {
          if (response.status === 200 || response.status === 201 ) {
            console.log(response)
            SuccessToast(expense_id ? "Expense updated" : "Expense added");
            navigate(-1);
          }
        })
        .catch((error) => {
          let message = "An error occurred.";
          if (error?.data?.errors) {
            message = Object.values(error.data.errors).flat().join(" ");
          }
          ErrorToast(message);
        });
    },
  });

  const handleReset = () => {
    formik.resetForm();
  };

  return (
    <div className="expense_form_super_container">
      <div className="expense_form_sub_container">
        <div className="expense_form_single_row_alignment">
          <IoArrowBackSharp
            className="expense_form_back"
            onClick={() => navigate(-1)}
          />
          <p className="expense_form_title">
            { expense_id
              ? "Update Expense Head"
              : "Add New Expense Head"}
          </p>
        </div>

          <div className="expense_form_single_row_alignment">
            {!expense_id && (
              <button
                className="expense_form_reset_button"
                type="button"
                onClick={handleReset}
              >
                Reset
              </button>
            )}
            <button
              className="expense_form_save_button"
              type="submit"
              form="expenseform"
            >
              Save
            </button>
          </div>
      </div>

      <form id="expenseform" onSubmit={formik.handleSubmit}>
        <div className="expense_form_main_container">
          <p className="expense_form_legend">Details</p>

          {/* Expense Name */}
          <div>
            <p className="expense_form_label">
              Name <span className="label_required_remark">*</span>
            </p>
            <CustomTextField
              name="expense_name"
              placeholder="Enter expense head"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.expense_name}
              error={
                formik.touched.expense_name &&
                Boolean(formik.errors.expense_name)
              }
              helperText={
                formik.touched.expense_name && formik.errors.expense_name
              }
            />
          </div>

          {/* Expense Status */}
          <div>
            <p className="expense_form_label">
              Status <span className="label_required_remark">*</span>
            </p>
            <CustomAutoCompleteDropdown
              name="expense_status"
              placeholder="Select a status"
              options={statusOptions}
              onChange={(event, newValue) =>
                formik.setFieldValue(
                  "expense_status",
                  newValue ? newValue.value : ""
                )
              }
              onBlur={formik.handleBlur}
              value={
                statusOptions.find(
                  (opt) => opt.value === formik.values.expense_status
                ) || null
              }
              error={
                formik.touched.expense_status &&
                Boolean(formik.errors.expense_status)
              }
              helperText={
                formik.touched.expense_status && formik.errors.expense_status
              }
            />
          </div>
        </div>
      </form>
    </div>
  );
}

export default ExpenseForm;
